const ELLIPSIS = '\u2026';

/** Tytuł w hero sekcji wideo — krótki jednowierszowy „billboard”. */
export const SHOWCASE_HERO_TITLE_MAX_CHARS = 72;

/** Lead pod tytułem — limit znaków (plain text po zdjęciu tagów). */
export const SHOWCASE_HERO_LEAD_MAX_CHARS = 220;

/** Etykieta werdyktu w kapsułce (hero) — zgodnie z `HERO_BADGE_LABEL_MAX` w video-showcase.ftl */
export const SHOWCASE_HERO_BADGE_LABEL_MAX_CHARS = 56;

/**
 * Skraca tekst do max. `maxChars` znaków (UTF-16 code units), z elipsą na końcu.
 * Gdy `maxChars` < 2, zwraca samą elipsę lub pusty string.
 */
export function truncateEnd(text: string, maxChars: number): string {
  const t = text.trim();
  if (maxChars < 1) {
    return '';
  }
  if (t.length <= maxChars) {
    return t;
  }
  if (maxChars === 1) {
    return ELLIPSIS;
  }
  const cut = maxChars - 1;
  return `${t.slice(0, cut).trimEnd()}${ELLIPSIS}`;
}
